import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface AuthState {
  userInfo: UserInfo | null
  token: string | null
  loading: boolean
  error: string | null
}
export interface UserInfo {
  name: string
  email: string
}

const initialState: AuthState = {
  userInfo: null,
  token: null,
  loading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true
      state.error = null
    },
    loginSuccess: (
      state,
      action: PayloadAction<{ token: string; userinfo: UserInfo }>
    ) => {
      state.token = action.payload.token
      state.userInfo = action.payload.userinfo
      state.loading = false
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    logOut: (state) => {
      state.userInfo = null
      state.token = null
    },
  },
})

export const { loginStart, loginSuccess, loginFailure, logOut } =
  authSlice.actions
export default authSlice.reducer

export const selectAuth = (state: RootState) => state.auth
export const selectIsLoggedIn = createSelector(
  [selectAuth],
  (auth) => auth.token !== null
)
export const selectToken = createSelector([selectAuth], (auth) => auth.token)
export const selectLoading = createSelector(
  [selectAuth],
  (auth) => auth.loading
)
export const selectError = createSelector([selectAuth], (auth) => auth.error)
export const selectUserInfo = createSelector(
  [selectAuth],
  (auth) => auth.userInfo
)
